import PortalIdParser from 'PortalIdParser';
import * as React from 'react';
import UserNameLabel from 'flow-doctor-lib/components/common/UserNameLabel';
import EnrollmentLogEventTimelineItemLabel from 'flow-doctor-lib/components/timeline/labels/EnrollmentLogEventTimelineItemLabel';
import UnifiedEventTimelineItemLabel from 'flow-doctor-lib/components/timeline/labels/UnifiedEventTimelineItemLabel';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UITruncateString from 'UIComponents/text/UITruncateString';
import ObjectTypeLabel from 'flow-doctor-lib/components/common/ObjectTypeLabel';
import ActionExecutionTimelineItemLabel from 'flow-doctor-lib/components/timeline/labels/ActionExecutionTimelineItemLabel';
import AssociationChangeTimelineItemLabel from 'flow-doctor-lib/components/timeline/labels/AssociationChangeTimelineItemLabel';
import AssociationPropertyChangeTimelineItemLabel from 'flow-doctor-lib/components/timeline/labels/AssociationPropertyChangeTimelineItemLabel';
import FlowRevisionTimelineItemLabel from 'flow-doctor-lib/components/timeline/labels/FlowRevisionTimelineItemLabel';
import FormSubmissionTimelineItemLabel from 'flow-doctor-lib/components/timeline/labels/FormSubmissionTimelineItemLabel';
import ListMembershipTimelineItemLabel from 'flow-doctor-lib/components/timeline/labels/ListMembershipTimelineItemLabel';
import PropertyChangeTimelineItemLabel from 'flow-doctor-lib/components/timeline/labels/PropertyChangeTimelineItemLabel';
import { jsx as _jsx } from "react/jsx-runtime";
const ObjectLifecycleStepLabel = ({
  flowId,
  logItem,
  objectTypeId
}) => {
  switch (logItem.type) {
    case 'ENROLLMENT_LOG_EVENT':
      {
        return /*#__PURE__*/_jsx(EnrollmentLogEventTimelineItemLabel, {
          logItem: logItem
        });
      }
    case 'PROPERTY_CHANGE':
      return /*#__PURE__*/_jsx(PropertyChangeTimelineItemLabel, {
        logItem: logItem,
        objectTypeId: objectTypeId
      });
    case 'ASSOCIATION_PROPERTY_CHANGE':
      return /*#__PURE__*/_jsx(AssociationPropertyChangeTimelineItemLabel, {
        logItem: logItem
      });
    case 'FORM_SUBMISSION':
      return /*#__PURE__*/_jsx(FormSubmissionTimelineItemLabel, {
        logItem: logItem
      });
    case 'LIST_MEMBERSHIP':
    case 'LIST_MEMBERSHIP_WITH_VISIBILITY':
      return /*#__PURE__*/_jsx(ListMembershipTimelineItemLabel, {
        logItem: logItem
      });
    case 'OBJECT_MERGE':
      return /*#__PURE__*/_jsx(UITruncateString, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: logItem.data.userId ? 'flow-doctor-lib.flows.objectLifecycle.objectMergeHistory.label.withUser_jsx' : 'flow-doctor-lib.flows.objectLifecycle.objectMergeHistory.label.withoutUser',
          elements: {
            ObjectTypeLabel,
            UserNameLabel
          },
          options: {
            objectTypeLabel: {
              portalId: PortalIdParser.get(),
              lowerCase: true,
              objectTypeId
            },
            objectId: logItem.data.mergedObjectId,
            userId: logItem.data.userId
          }
        })
      });
    case 'FLOW_REVISION':
      {
        return /*#__PURE__*/_jsx(FlowRevisionTimelineItemLabel, {
          logItem: logItem
        });
      }
    case 'UNIFIED_EVENT':
      {
        return /*#__PURE__*/_jsx(UnifiedEventTimelineItemLabel, {
          logItem: logItem
        });
      }
    case 'ACTION_EXECUTION_LOG_EVENT':
      return /*#__PURE__*/_jsx(ActionExecutionTimelineItemLabel, {
        flowId: flowId,
        logItem: logItem
      });
    case 'ASSOCIATION_CHANGE':
      return /*#__PURE__*/_jsx(AssociationChangeTimelineItemLabel, {
        logItem: logItem
      });
    default:
      throw new Error(`Unrecognized TimelineLogItem type ${logItem.type}. Please add it`);
  }
};
export default ObjectLifecycleStepLabel;